import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Store } from "@modules/stores/types/store";

import { ListStoresQueryFilters } from "./types";

export async function getStoresService(filters?: ListStoresQueryFilters): Promise<Store[]> {
  try {
    const { data } = await api.get<ApiResponse<Store>>(`v1/store_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching stores:", error);
    throw error;
  }
}
